var render, staticRenderFns
import script from "./fbaRailwayExport.vue?vue&type=script&lang=js&"
export * from "./fbaRailwayExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c416364')) {
      api.createRecord('0c416364', component.options)
    } else {
      api.reload('0c416364', component.options)
    }
    
  }
}
component.options.__file = "src/views/cargo/v0/FBA/fbaRailwayExport.vue"
export default component.exports